import {
	Grid,
	List,
	ListItem,
	Theme,
	Typography,
	makeStyles
} from "@material-ui/core";
import { Overwrite } from "@material-ui/types";
import { BaseFieldProps, FieldEditorOptions, HasItems } from "./types";
import { FieldProps } from "formik";
import {
	defaultGetItemLabel,
	identityRecordOfFieldEditorOptions
} from "./utils";
import clsx from "clsx";

const useStyles = makeStyles(
	(theme: Theme) => ({
		list: { display: "flex", flexDirection: "column", rowGap: "6px" },
		listItem: {
			border: "1px solid #C1BEBB",
			borderRadius: "4px",
			backgroundColor: theme.palette.common.white,
			padding: "11px 14px",
			justifyContent: "space-between"
		},
		listItemLiteral: {
			justifyContent: "space-between"
		}
	}),
	{ name: "DployListField" }
);

export interface ListFieldProps<T>
	extends Overwrite<FieldProps, HasItems<T>>,
		Overwrite<BaseFieldProps, HasItems<T>> {
	literal: boolean;
}

export function ListField<T extends any>(props: ListFieldProps<T>) {
	const {
		field,
		label,
		suffix,
		getItemLabel = defaultGetItemLabel,
		literal
	} = props;
	const classes = useStyles(props);
	const items = field.value;
	if (!items || items.length === 0) {
		return null;
	}
	return (
		<Grid container direction="column">
			{!literal && label && label?.toString().trim().length > 0 ? (
				<Typography variant="caption">{label}</Typography>
			) : null}
			<List className={classes.list}>
				{items.map(x => {
					const label: string = getItemLabel(x);
					const labelSplit = label.split(";");
					return (
						<ListItem
							key={label}
							className={clsx({
								[classes.listItem]: !literal,
								[classes.listItemLiteral]: literal
							})}
							disableGutters
						>
							<Typography variant="body1">{labelSplit[0]}</Typography>
							<Typography variant="body1">
								{labelSplit[1]}
								{suffix}
							</Typography>
						</ListItem>
					);
				})}
			</List>
		</Grid>
	);
}

ListField.displayName = "DployListField";

const listFieldEditorProps: FieldEditorOptions = {
	editableOptions: {
		suffix: true
	}
};

export const EditorListFields = identityRecordOfFieldEditorOptions({
	ListField: listFieldEditorProps
});
